import { useEffect } from 'react';

import { PdfViewerLoadable } from '#/components/PdfViewer/PdfViewerLoadable';
import { LayoutFullWidthBody } from '#/layouts/Layout/LayoutFullWidthBody';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

type Props = {
  filename: string;
};

export function CmsViewFilePage({ filename }: Props) {
  useEffect(() => {
    trackPageView('Pdf Viewer', {
      url: `/files/${filename}`,
      filename,
    });
  }, [filename]);

  const files = [
    {
      url: `/files/${filename}?download=true`,
      downloadUrl: `/files/${filename}?download=true`,
      label: filename,
      id: filename,
    },
  ];

  return (
    <LayoutFullWidthBody $centered>
      <PdfViewerLoadable files={files} shareUrl={`/files/${filename}`} />
    </LayoutFullWidthBody>
  );
}
